export default __webpack_public_path__ + "static/media/pin-login.911167f5.png";